import { cmsAxios } from '../../../../http-common';

class CalculatorDataService {
  getAllCalculatorType() {
    return cmsAxios.get(`/f/content_management/calculator-type/`);
  }

  getSingleCalculatorType(id: number) {
    return cmsAxios.get(`/f/content_management/calculator-type/${id}/`, {
      headers: {
        Authorization: `Bearer ${process.env.CMS_TOKEN}`,
      },
    });
  }
  getAllCalculatorList() {
    return cmsAxios.get(`/f/content_management/calculator/`, {
      headers: {
        Authorization: `Bearer ${process.env.CMS_TOKEN}`,
      },
    });
  }
  getSingleCalculator(externalID: string) {
    return cmsAxios.get(`/f/content_management/calculator/${externalID}/`, {
      headers: {
        Authorization: `Bearer ${process.env.CMS_TOKEN}`,
      },
    });
  }
}

export default new CalculatorDataService();
